<template>
  <div class="sidebar-container" :class="{ 'is-collapsed': isCollapse }">
    <!-- Logo 区域 -->
    <div class="logo-wrapper">
      <div class="logo">
        <img :src="userAvatar" alt="avatar" class="user-avatar" />
        <span v-show="!isCollapse" class="logo-text">{{ userName }}</span>
      </div>
    </div>

    <!-- 菜单区域（权限控制生效） -->
    <el-menu
      :default-active="$route.path"
      mode="vertical"
      :collapse="isCollapse"
      :collapse-transition="false"
      background-color="#1e293b"
      text-color="#cbd5e1"
      active-text-color="#60a5fa"
      router
      class="sidebar-menu"
    >
      <el-menu-item index="/HomeBack">
        <el-icon><House /></el-icon>
        <span>控制台</span>
      </el-menu-item>
      <el-menu-item index="/DashboardMx" v-if="hasPerm('dashboard:mix')">
        <el-icon><DataAnalysis /></el-icon>
        <span>进销存看板</span>
      </el-menu-item>

      <!-- 产品管理：有任一子权限就显示父菜单 -->
      <el-sub-menu index="/ProductSystem" v-if="hasPerm('product:list') || hasPerm('product:gallery')">
        <template #title>
          <el-icon><Goods /></el-icon>
          <span>产品管理</span>
        </template>
        <el-menu-item index="/ProductSystem/ProductList" v-if="hasPerm('product:list')">产品列表</el-menu-item>
        <el-menu-item index="/ProductSystem/ProductGallery" v-if="hasPerm('product:gallery')">产品图库</el-menu-item>
      </el-sub-menu>

      <!-- 销售管理：有权限才显示 -->
      <el-sub-menu index="/SalesSystem" v-if="hasPerm('sale:list') || hasPerm('saleChance:list') || hasPerm('saleChance:follow') || hasPerm('userData:list') || hasPerm('order:list')">
        <template #title>
          <el-icon><Sell /></el-icon>
          <span>销售管理</span>
        </template>
        <el-menu-item index="/SaleSystem/SaleList" v-if="hasPerm('sale:list')">销售列表</el-menu-item>
        <el-menu-item index="/SaleSystem/SaleChanceList" v-if="hasPerm('saleChance:list')">销售机会</el-menu-item>
        <el-menu-item index="/SaleSystem/SaleChanceFollowList" v-if="hasPerm('saleChance:follow')">跟进记录</el-menu-item>
        <el-menu-item index="/SaleSystem/UserDataList" v-if="hasPerm('userData:list')">电商用户</el-menu-item>
        <el-menu-item index="/SaleSystem/OrderList" v-if="hasPerm('order:list')">电商订单</el-menu-item>
        <el-menu-item index="/SaleSystem/ContactMessageList" v-if="hasPerm('contactMessage:list')">用户留言</el-menu-item>
      </el-sub-menu>

      <!-- 库存管理：有任一子权限就显示父菜单 -->
      <el-sub-menu index="/InventorySystem" v-if="hasPerm('warehouse:list') || hasPerm('purchase:list') || hasPerm('stock:in') || hasPerm('stock:out') || hasPerm('channelPurchase:list')">
        <template #title>
          <el-icon><Goods /></el-icon>
          <span>库存管理</span>
        </template>
        <el-menu-item index="/InventorySystem/WarehouseList" v-if="hasPerm('warehouse:list')">仓库管理</el-menu-item>
        <el-menu-item index="/InventorySystem/PurchaseList" v-if="hasPerm('purchase:list')">采购管理</el-menu-item>
        <el-menu-item index="/InventorySystem/StockInList" v-if="hasPerm('stock:in')">入库管理</el-menu-item>
        <el-menu-item index="/InventorySystem/StockOutList" v-if="hasPerm('stock:out')">出库管理</el-menu-item>
        <el-menu-item index="/InventorySystem/ChannelPurchaseList" v-if="hasPerm('channelPurchase:list')">渠道采购</el-menu-item>
      </el-sub-menu>

      <!-- 财务管理：有任一子权限就显示父菜单 -->
      <el-sub-menu index="/FinanceSystem" v-if="hasPerm('account:list') || hasPerm('dailyAccount:list')">
        <template #title>
          <el-icon><Wallet /></el-icon>
          <span>财务管理</span>
        </template>
        <el-menu-item index="/FinanceSystem/FinanceDashboard" v-if="hasPerm('dailyAccount:list')">财务看板</el-menu-item>
        <el-menu-item index="/FinanceSystem/AccountList" v-if="hasPerm('account:list')">账户管理</el-menu-item>
        <el-menu-item index="/FinanceSystem/DailyAccountList" v-if="hasPerm('dailyAccount:list')">流水记账</el-menu-item>
      </el-sub-menu>

      <!-- 供应链管理：有权限才显示 -->
      <el-sub-menu index="/SupplyChainSystem" v-if="hasPerm('supplier:list') || hasPerm('rawMaterial:list') || hasPerm('rawMaterialPurchase:list') || hasPerm('rawMaterialIn:list') || hasPerm('rawMaterialOut:list')">
        <template #title>
          <el-icon><Document /></el-icon>
          <span>供应链管理</span>
        </template>
        <el-menu-item index="/SupplyChainSystem/SupplierPurchaseStats" v-if="hasPerm('supplier:list') || hasPerm('rawMaterialPurchase:list')">供应商采购汇总</el-menu-item>
        <el-menu-item index="/SupplyChainSystem/SupplierList" v-if="hasPerm('supplier:list')">供应商列表</el-menu-item>
        <el-menu-item index="/SupplyChainSystem/RawMaterialList" v-if="hasPerm('rawMaterial:list')">原材料列表</el-menu-item>
        <el-menu-item index="/SupplyChainSystem/RawMaterialPurchaseList" v-if="hasPerm('rawMaterialPurchase:list')">原材料采购</el-menu-item>
        <el-menu-item index="/SupplyChainSystem/RawMaterialInList" v-if="hasPerm('rawMaterialIn:list')">原材料入库</el-menu-item>
        <el-menu-item index="/SupplyChainSystem/RawMaterialOutList" v-if="hasPerm('rawMaterialOut:list')">原材料出库</el-menu-item>
      </el-sub-menu>

      <!-- 物料管理：有权限才显示 -->
      <el-sub-menu index="/MaterialSystem" v-if="hasPerm('material:list') || hasPerm('materialPurchase:list') || hasPerm('materialIn:list') || hasPerm('materialOut:list')">
        <template #title>
          <el-icon><Document /></el-icon>
          <span>物料管理</span>
        </template>
        <el-menu-item index="/MaterialSystem/MaterialList" v-if="hasPerm('material:list')">物料列表</el-menu-item>
        <el-menu-item index="/MaterialSystem/MaterialPurchaseList" v-if="hasPerm('materialPurchase:list')">物料采购</el-menu-item>
        <el-menu-item index="/MaterialSystem/MaterialInList" v-if="hasPerm('materialIn:list')">物料入库</el-menu-item>
        <el-menu-item index="/MaterialSystem/MaterialOutList" v-if="hasPerm('materialOut:list')">物料出库</el-menu-item>
      </el-sub-menu>
      <el-sub-menu index="/ProductionSystem" v-if="hasPerm('productionPlan:list') || hasPerm('productionProduct:list') || hasPerm('rawMaterial:list') || hasPerm('bom:list') || hasPerm('customProduction:list')">
        <template #title>
          <el-icon><Operation /></el-icon>
          <span>生产管理</span>
        </template>
        <el-menu-item index="/ProductionSystem/BomList" v-if="hasPerm('bom:list')">BOM清单</el-menu-item>
        <el-menu-item index="/ProductionSystem/ProductionPlanList" v-if="hasPerm('productionPlan:list')">生产计划</el-menu-item>
        <el-menu-item index="/ProductionSystem/ProductionProductList" v-if="hasPerm('productionProduct:list')">生产产品</el-menu-item>
        <el-menu-item index="/ProductionSystem/RawMaterialList" v-if="hasPerm('rawMaterial:list')">原料需求</el-menu-item>
        <el-menu-item index="/ProductionSystem/CustomProductionList" v-if="hasPerm('customProduction:list') || hasPerm('productionPlan:list')">定制生产表</el-menu-item>
      </el-sub-menu>
      <!-- ======================
           网站管理：加权限！
           有 website:list 或 webPage:list 才显示
      ======================= -->
      <el-sub-menu index="/WebSystem" v-if="hasPerm('website:list') || hasPerm('webPage:list')">
        <template #title>
          <el-icon><Document /></el-icon>
          <span>网站管理</span>
        </template>
        <el-menu-item index="/Website/WebsiteList" v-if="hasPerm('website:list')">网站列表</el-menu-item>
        <el-menu-item index="/Website/WebPageList" v-if="hasPerm('webPage:list')">页面管理</el-menu-item>
        <el-menu-item index="/Website/ModuleContentList" v-if="hasPerm('webPage:list')">素材管理</el-menu-item>
        <el-menu-item index="/Website/ArticleList/news" v-if="hasPerm('webPage:list')">新闻管理</el-menu-item>
        <el-menu-item index="/Website/ArticleList/dynamics" v-if="hasPerm('webPage:list')">企业动态</el-menu-item>
      </el-sub-menu>

      <!-- ======================
           培训管理：加权限！
           有 train:list 或 trainSign:list 才显示
      ======================= -->
      <el-sub-menu index="/CompanyTrainSystem" v-if="hasPerm('train:list') || hasPerm('trainSign:list')">
        <template #title>
          <el-icon><Document /></el-icon>
          <span>培训管理</span>
        </template>
        <el-menu-item index="/CompanyTrainSystem/TrainCompanyList" v-if="hasPerm('train:list')">培训企业</el-menu-item>
        <el-menu-item index="/CompanyTrainSystem/TrainCourseList" v-if="hasPerm('train:list')">培训列表</el-menu-item>
      </el-sub-menu>

      <!-- 用户管理：有权限才显示 -->
      <el-sub-menu index="/userSystem" v-if="hasPerm('user:list') || hasPerm('role:list')">
        <template #title>
          <el-icon><User /></el-icon>
          <span>用户管理</span>
        </template>
        <el-menu-item index="/usersSystem/UserList" v-if="hasPerm('user:list')">用户列表</el-menu-item>
        <el-menu-item index="/usersSystem/RoleList" v-if="hasPerm('role:list')">权限管理</el-menu-item>
      </el-sub-menu>

      <el-sub-menu index="/adminSystem" v-if="hasPerm('user:list') || hasPerm('role:list')">
        <template #title>
          <el-icon><DocumentCopy /></el-icon>
          <span>操作日志</span>
        </template>
        <el-menu-item index="/adminSystem/LogList" v-if="hasPerm('user:list')">销售日志</el-menu-item>
        <el-menu-item index="/adminSystem/FrontendUpdateLog">界面日志</el-menu-item>
        <el-menu-item index="/adminSystem/SystemUpdateLog">更新日志</el-menu-item>
        <el-menu-item index="/adminSystem/PageViewStats">浏览统计</el-menu-item>
      </el-sub-menu>
    </el-menu>
  </div>
</template>

<script>
/* eslint-disable */
import { House, User, Document, Setting, DocumentCopy, Goods, Sell, Wallet, DataAnalysis } from '@element-plus/icons-vue'

export default {
  name: "SidebarBackend",
  components: { House, User, Document, Setting, DocumentCopy, Goods, Sell, Wallet, DataAnalysis },
  data() {
    return {
      isCollapse: false
    }
  },
  provide() {
    return {
      collapse: this.isCollapse
    }
  },
  computed: {
    userAvatar() {
      try {
        const info = JSON.parse(localStorage.getItem('userInfo') || '{}')
        return info.avatar || 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'
      } catch { return 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png' }
    },
    userName() {
      try {
        const info = JSON.parse(localStorage.getItem('userInfo') || '{}')
        return info.real_name || info.username || '管理员'
      } catch { return '管理员' }
    }
  },
  watch: {
    isCollapse(val) {
      this.$emit('collapse', val)
    }
  },
  methods: {
    hasPerm(permKey) {
      try {
        const pStr = localStorage.getItem('perms') || localStorage.getItem('userPerms') || '[]'
        const userPerms = JSON.parse(pStr)
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')

        if (userInfo.role_id === 1) {
          return true
        }

        return userPerms.includes(permKey)
      } catch (e) {
        return false
      }
    }
  }
}
</script>

<style scoped>
.sidebar-container {
  width: 240px;
  height: 100vh;
  background-color: #1e293b;
  transition: width 0.3s ease;
  overflow: hidden;
  flex-shrink: 0;
}

.sidebar-container.is-collapsed {
  width: 64px;
}

.logo-wrapper {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #334155;
}

.logo {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
}

.logo .user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.logo-text {
  transition: opacity 0.3s ease;
}

.sidebar-menu {
  border: none;
  width: 100%;
}

:deep(.el-menu-item) {
  height: 48px;
  line-height: 48px;
}

:deep(.el-sub-menu__title) {
  height: 48px;
  line-height: 48px;
}
</style>